/* Horizontal card rails on the home page (4-tile card rows, department tile rows):
   native scroll-snap track + round arrow buttons that scroll one card width per click.
   Arrows hide when the track does not overflow; keyboard users tab to the buttons. */
(function () {
  function init(rail) {
    if (rail.dataset.railReady) return;
    rail.dataset.railReady = '1';
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track || !prev || !next) return;
    var step = function () {
      var card = track.querySelector(':scope > *');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 1;
      var overflow = max > 2;
      rail.classList.toggle('has-overflow', overflow);
      prev.disabled = !overflow || track.scrollLeft <= 1;
      next.disabled = !overflow || track.scrollLeft >= max;
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var ticking = false;
    track.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    document.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.contains(rail)) window.removeEventListener('resize', update); });
    update();
  }
  var boot = function () { document.querySelectorAll('[data-home-rail]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
